import { render, staticRenderFns } from "./AdditionalInfoFromTemplate.vue?vue&type=template&id=c4cb7cf8"
import script from "./AdditionalInfoFromTemplate.vue?vue&type=script&lang=js"
export * from "./AdditionalInfoFromTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports